import { useEffect, useRef } from 'react';

export default function useResizeObserver(
  ref: HTMLElement,
  onResize: () => void,
): void {

  const callbackRef = useRef<(() => void)>(onResize);
  callbackRef.current = onResize;

  useEffect(() => {
    if (!ref) {
      return undefined;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      window.requestAnimationFrame((): void | undefined => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        callbackRef?.current();
      });
    });
    resizeObserver.observe(ref);

    return () => resizeObserver.disconnect();
  }, [ref]);
}
